import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { Clipboard } from '@capacitor/clipboard';
import {
  IonicModule,
  ModalController,
  Platform,
  ToastController
} from '@ionic/angular';
import { FeatureTogglesService } from 'src/app/services/feature-toggles/feature-toggles.service';
import { FeatureToggle } from 'src/app/services/feature-toggles/toggles.types';
import { RingMegService } from 'src/app/services/ring-meg/ring-meg.service';
import { SelvbetjeningService } from 'src/app/services/selvbetjening/selvbetjening.service';

@Component({
  selector: 'app-contact-us-modal',
  templateUrl: './contact-us-modal.component.html',
  styleUrls: ['./contact-us-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule]
})
export class ContactUsModalComponent {
  contactForm: FormGroup;
  isApp: boolean;
  showConfirm: boolean = false;
  callbackDisabled: boolean = true;

  constructor(
    public modalCtrl: ModalController,
    public platform: Platform,
    public toastCtrl: ToastController,
    public ringMegService: RingMegService,
    public selvbetjeningService: SelvbetjeningService,
    public toggleService: FeatureTogglesService
  ) {}

  ngOnInit() {
    this.isApp = this.platform.is('capacitor');
    this.toggleService.getActiveFeatureToggles().subscribe({
      next: (res) => {
        this.callbackDisabled = this.getIsCallbackDisabled(res) ?? true;
      },
      error: (err) => {
        this.callbackDisabled = true;
      }
    });
    this.selvbetjeningService.getContact().subscribe({
      next: (res) => {
        const ucMobile =
          (
            res.accounts.find((x) => x.Guid === res.customer.DefaultAccount) ||
            res.accounts[0]
          )?.Communication.find((x) => x.Channel === 'Mobile')?.Value || '';
        const ucName = res.customer?.GivenName || '';
        this.initForm(ucMobile, ucName);
      },
      error: (err) => {
        this.initForm('', '');
      }
    });
  }

  initForm(mobile: string, name: string) {
    this.contactForm = new FormGroup({
      phone: new FormControl(
        mobile ?? '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^[0-9 +-_]{8,}$')
        ])
      ),
      name: new FormControl(name ?? '')
    });
  }

  sendContact() {
    const payload = JSON.stringify({
      origin: 'app',
      trigger: 'app',
      source: 'app',
      mobile: this.contactForm.get('phone').value,
      name: this.contactForm.get('name').value
    });
    this.ringMegService.ringMeg(payload).subscribe({
      next: (res) => {
        this.showConfirm = true;
      },
      error: (err) => {
        // Det er noe galt med responsen, så vi havner her...
        if (err.status === 200) {
          this.showConfirm = true;
        } else {
          this.toastCtrl
            .create({
              message: 'Det skjedde dessverre en feil, prøv igjen litt senere.',
              duration: 4000,
              position: 'middle',
              color: 'danger'
            })
            .then((toast) => {
              toast.present();
            });
        }
      }
    });
  }

  copyEmail() {
    if (this.isApp) {
      Clipboard.write({
        string: 'kunde@ishavskraft.no'
      }).then(() => this.confirmCopy());
    } else {
      navigator.clipboard
        .writeText('kunde@ishavskraft.no')
        .then(() => this.confirmCopy());
    }
  }

  copyPhone() {
    if (this.isApp) {
      Clipboard.write({
        string: '+4777612000'
      }).then(() => this.confirmCopy());
    } else {
      navigator.clipboard
        .writeText('+4777612000')
        .then(() => this.confirmCopy());
    }
  }

  confirmCopy() {
    this.toastCtrl
      .create({
        message: 'Kopiért',
        duration: 2500,
        position: 'middle',
        color: 'success'
      })
      .then((toast) => {
        toast.present();
      });
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  getIsCallbackDisabled(toggles: FeatureToggle[]): boolean {
    const myToggle = toggles.find((x) => x.navn === 'deaktiver_ringmeg');
    return myToggle ? myToggle.toggleActive === 'NOW' : false;
  }
}
